
import { Options, Vue } from 'vue-class-component'
import * as echarts from 'echarts'

let countryList = '奥地利、比利时、捷克、丹麦、爱沙尼亚、芬兰、法国、德国、希腊、匈牙利、冰岛、意大利、拉脱维亚、立陶宛、卢森堡、马耳他、荷兰、波兰、葡萄牙、斯洛伐克、斯洛文尼亚、西班牙、瑞典、瑞士、摩纳哥、俄罗斯、英国、爱尔兰、塞浦路斯、保加利亚、罗马尼亚、乌克兰、塞尔维亚、克罗地亚、波黑、黑山、北马其顿、阿尔巴尼亚、白俄罗斯、挪威、美国、加拿大、巴西、墨西哥、阿根廷、智利、澳大利亚、新西兰、韩国、日本、新加坡、文莱、阿联酋、卡塔尔'.split('、');
let portList = '北京首都国际机场、北京大兴国际机场、北京西客站、天津滨海国际机场、天津国际邮轮母港、石家庄正定国际机场、秦皇岛海港(客运)、上海虹桥国际机场、上海浦东国际机场、上海海港口岸(客运)、上海铁路口岸、南京禄口国际机场、连云港海港口岸(客运)、杭州萧山国际机场、宁波栎社国际机场、温州港口岸(客运)、舟山港口岸(客运)、广州白云国际机场、南沙港口岸(客运)、深圳宝安国际机场、蛇口港口岸(客运)、揭阳潮汕国际机场、沈阳桃仙国际机场、大连周水子国际机场、大连港口岸(客运)、青岛胶东国际机场、青岛海港口岸(客运)、郑州新郑国际机场、重庆江北国际机场、昆明长水国际机场、丽江三义国际机场、磨憨铁路口岸、成都双流国际机场、西安咸阳国际机场、厦门高崎国际机场、厦门海港口岸(客运)、武汉天河国际机场'.split('、');
let myChart, dotInte;
@Options({
  props: ['count'],
  watch: {
    count() {
      clearInterval(dotInte);
      myChart && myChart.dispose();
      myChart && (myChart = null);
      this.char();
    }
  },
  mounted() {
    this.char();
  },
  beforeDestroy() {
    clearInterval(dotInte);
    myChart.dispose();
    myChart = null;
  },
  methods: {
    char() {
        const _this = this;
        clearInterval(dotInte);
        const vw = document.documentElement.clientWidth || document.body.clientWidth;
        const chartDom = document.getElementById('travel-container');
        myChart = echarts.init(chartDom);

        // 计算数据点
        function generateData(count) {
            let data: any = [];
            for (let i = 0; i < count; i++) {
                const angle = (i / count) * Math.PI * 32; // 角度范围是从0到2π
                const radius = 100; // 半径固定为100单位
                const size = 20; // 随机生成气泡大小
                const r = 50 + Math.abs(Math.random() * 50);
                const value = [Math.random() > 0.5 ? r : -r, radius * Math.sin(angle)];
                data.push({value: [...value, size]});
            }
            return data;
        }

        // 指定图表的配置项
        let option = {
            tooltip: false,
            polar: {
                center: ['50%', '50%'], // 圆心位置
                radius: '80%'          // 半径大小
            },
            angleAxis: { // 角度轴配置
                type: 'value',
                min: -100,
                max: 100,
                startAngle: 45,
                axisLine: { // 关闭轴线显示
                    show: false
                },
                axisTick: { // 关闭刻度线显示
                    show: false
                },
                splitLine: { // 关闭分割线显示
                    show: false
                },
                axisLabel: { // 关闭标签显示
                    show: false
                }
            },
            radiusAxis: { // 半径轴配置
                type: 'value',
                min: 0,
                max: 100,
                axisLine: { // 关闭轴线显示
                    show: false
                },
                axisTick: { // 关闭刻度线显示
                    show: false
                },
                splitLine: { // 关闭分割线显示
                    show: false
                },
                axisLabel: { // 关闭标签显示
                    show: false
                }
            },
            series: [
                {
                    name: 'dot',
                    type: 'scatter',
                    coordinateSystem: 'polar',
                    data: generateData(1000),
                    symbolSize: function () {
                        return Math.floor(Math.random() * vw * 0.025);
                    },
                    label: {
                        show: false,
                        formatter: '{b}',
                        color: '#ffffff'
                    },
                    itemStyle: {
                        color: 'rgba(25, 176, 231, 0.1)' // 设置气泡颜色
                    }
                },
                {
                    name: 'country',
                    type: 'scatter',
                    coordinateSystem: 'polar',
                    data: generateData(this.count),
                    symbolSize: Math.floor(vw * 0.05),
                    label: {
                        show: false,
                        formatter: '{b}',
                        color: '#ffffff',
                    },
                    itemStyle: {
                        color: this.count === 37 ? '#68d4b6' : 'rgba(25, 176, 231, 1)' // 设置气泡颜色
                    }
                },
            ]
        };
            
        // 使用刚指定的配置项和数据显示图表。
        myChart.setOption(option);

        // 监听点击事件
        myChart.on('click', function(params) {
            if (params.seriesName === 'country' && params.componentType === 'series' && params.seriesType === 'scatter') {
                // 获取被点击的数据索引
                var dataIndex = params.dataIndex;
                clearInterval(dotInte);
                dot(dataIndex);
            }
        });

        function dot(dataIndex) {
            // 获取当前的数据集合
            var seriesData: any = option.series[1].data;
            seriesData.map(item => {
                item.name = null;
            });
            let name = portList[dataIndex];
            if (_this.count === 54) {
                name = countryList[dataIndex];
            }
            seriesData[dataIndex]['name'] = name || '';
            // 设置name文字大小
            seriesData[dataIndex]['fontSize'] = Math.floor(vw * 0.1);
            let fontSize = name.length > 3 ? 10 : 15;
            if (name.length > 5) {
                fontSize = 6;
            }

            // 更新图表数据
            myChart.setOption({
                series: [
                    option.series[0],
                    {
                        data: seriesData,
                        symbolSize: function (val, idx) {
                            if (idx.dataIndex === dataIndex) {
                                return Math.floor(vw * 0.15);
                            }
                            return Math.floor(vw * 0.05);
                        },
                        label: {
                            show: true,
                            formatter: '{b}',
                            fontSize,
                        },
                    }
                ]
            });
        }

        dotInte = setInterval(() => {
            myChart.resize();
            dot(Math.floor(Math.random() * _this.count));
        }, 3000);
    }
  },
})
export default class Country extends Vue {}
